import { useEffect, useState } from "react";
import styles from "./Facility.module.css";

import GetBroadcasts from "../../components/getBroadcasts/GetBroadcasts";

type Site = {
	active: boolean;
	city: string;
	date_modified: string;
	default_distribution_network: string;
	default_revenue_model: string;
	id: string;
	large_image: string;
	lat: string;
	lon: string;
	medium_image: string;
	owner_id: string;
	slug: string;
	small_image: string;
	state: string;
	street_address: string;
	title: string;
};
interface Props {
	facilityId: string;
	selectBroadcast: (id: string) => void;
}
const Facility = ({ facilityId, selectBroadcast }: Props) => {
	const [siteData, setSiteData] = useState<Site>(null!);

	useEffect(() => {
		const getSiteData = async () => {
			// Get currently live games at this facility
			await fetch(`https://arbiter.musco.io/pub/facility?id=${facilityId}`)
				.then((response) => response.text())
				.then((result) => {
					const data = JSON.parse(result);
					setSiteData(data);
				})
				.catch((err) => {
					//Todo
					// setError(true);
				});
		};
		getSiteData();
	}, [facilityId]);

	return (
		<div className={styles.facility}>
			<section
				data-testid="header"
				className={styles.facilityImg}
				style={siteData ? { backgroundImage: `url(${siteData.large_image})` } : undefined}
			></section>
			<section className={styles.facilityHeader}>
				{siteData ? <h1 className="text-body">{siteData.title}</h1> : null}
			</section>
			<section className={styles.contentSection}>
				<div className={styles.expandableList}>
					{/* Live broadcasts */}
					<GetBroadcasts
						facilityID={facilityId}
						isLoading={false}
						viewerStatus={"streaming"}
						filters={null}
						hideTitle={false}
						selectBroadcast={selectBroadcast}
					/>
				</div>
				<div className={styles.expandableList}>
					{/* Upcoming broadcasts */}
					<GetBroadcasts
						facilityID={facilityId}
						isLoading={false}
						viewerStatus={"scheduled"}
						filters={null}
						hideTitle={false}
						selectBroadcast={selectBroadcast}
					/>
				</div>
				<div className={styles.expandableList}>
					{/* Archived broadcasts */}
					<GetBroadcasts
						facilityID={facilityId}
						isLoading={false}
						viewerStatus={"archived"}
						filters={null}
						hideTitle={false}
						selectBroadcast={selectBroadcast}
					/>
				</div>
			</section>
		</div>
	);
};

export default Facility;
